import { flow } from 'lodash';
import MultipleChoice from './MultipleChoice';
import withUserInput from '../../hocs/UserInput';
import withValidation from '../../hocs/Validation';

export default flow(withUserInput, withValidation)(MultipleChoice);



// WEBPACK FOOTER //
// ../core/src/components/MultipleChoice/index.js